import * as logger from '@owl-nest/logger'

const CONFIG_PATH = '/ufe/config/'

export type UfeConfigResponse = {
  UFE: {
    locale: string
    country: string
    localeFile?: string
  }
  CURRENCIES: {
    CURRENT: string
  }
}

const BROWSER_CONFIG_REQUESTS: Record<string, Promise<UfeConfigResponse>> = {}

export function getUfeConfig(origin = ''): Promise<UfeConfigResponse> {
  const endpoint = getUfeConfigEndpoint(origin)

  if (typeof window === 'undefined') {
    return fetchUfeConfig(endpoint)
  }

  if (!(endpoint in BROWSER_CONFIG_REQUESTS)) {
    BROWSER_CONFIG_REQUESTS[endpoint] = fetchUfeConfig(endpoint)
  }

  return BROWSER_CONFIG_REQUESTS[endpoint]
}

export function getUfeConfigEndpoint(origin = ''): string {
  if (origin) {
    try {
      const originUrl = new URL(origin)

      if (typeof window !== 'undefined' && originUrl.host === window.location.host) {
        return CONFIG_PATH
      }

      return new URL(CONFIG_PATH, originUrl).toString()
    } catch (error) {
      const fallbackEndpoint = `${origin}${CONFIG_PATH}`
      logger.err('[config] Failed to parse UFE config origin, using fallback endpoint', {
        configPath: CONFIG_PATH,
        fallbackEndpoint,
        origin,
        errorMessage: error instanceof Error ? error.message : String(error),
        errorName: error instanceof Error ? error.name : 'UnknownError',
      })
      return fallbackEndpoint
    }
  }

  return CONFIG_PATH
}

async function fetchUfeConfig(endpoint: string): Promise<UfeConfigResponse> {
  const response = await fetch(endpoint)

  if (!response.ok) {
    throw new Error(`[config] Failed to load UFE config (${response.status}: ${response.statusText})`)
  }

  return (await response.json()) as UfeConfigResponse
}
